var _rect, _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.1216,
    height: 12.9814,
    rx: 2,
    transform: "matrix(0.732551 0.680712 -0.676308 0.736619 24.3529 3)",
    fill: "url(#paint0_linear_1971_75039)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1971_75039)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1971_75039",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3375 8.46296C20.0301 7.70852 21.1996 7.66183 21.9495 8.35868L27.3809 13.4057C28.1308 14.1026 28.1772 15.2791 27.4846 16.0336L16.8916 27.5712C16.4369 28.0664 15.8571 28.4279 15.214 28.6172L12.0591 29.5459L7.1709 25.0036L7.8409 21.7659C7.9775 21.106 8.28982 20.4958 8.74445 20.0006L19.3375 8.46296Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.3375 8.46296C20.0301 7.70852 21.1996 7.66183 21.9495 8.35868L27.3809 13.4057C28.1308 14.1026 28.1772 15.2791 27.4846 16.0336L16.8916 27.5712C16.4369 28.0664 15.8571 28.4279 15.214 28.6172L12.0591 29.5459L7.1709 25.0036L7.8409 21.7659C7.9775 21.106 8.28982 20.4958 8.74445 20.0006L19.3375 8.46296Z",
    fill: "#F8B77B",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9495 8.35868L21.8919 8.42071L21.9495 8.35868ZM19.3375 8.46296L19.2751 8.40569L19.3375 8.46296ZM27.3809 13.4057L27.3233 13.4678L27.3809 13.4057ZM27.4846 16.0336L27.547 16.0908L27.4846 16.0336ZM16.8916 27.5712L16.8292 27.5139L16.8916 27.5712ZM15.214 28.6172L15.2379 28.6985L15.214 28.6172ZM12.0591 29.5459L12.0015 29.6079L12.0368 29.6407L12.083 29.6271L12.0591 29.5459ZM7.1709 25.0036L7.08797 24.9864L7.07831 25.0331L7.11325 25.0656L7.1709 25.0036ZM7.8409 21.7659L7.75797 21.7487L7.75797 21.7487L7.8409 21.7659ZM8.74445 20.0006L8.68207 19.9433L8.74445 20.0006ZM22.0071 8.29665C21.2228 7.5678 19.9995 7.61668 19.2751 8.40569L19.3998 8.52023C20.0608 7.80035 21.1764 7.75586 21.8919 8.42071L22.0071 8.29665ZM27.4386 13.3437L22.0071 8.29665L21.8919 8.42071L27.3233 13.4678L27.4386 13.3437ZM27.547 16.0908C28.2711 15.3021 28.2226 14.0723 27.4386 13.3437L27.3233 13.4678C28.0391 14.1329 28.0834 15.2561 27.4222 15.9763L27.547 16.0908ZM16.9539 27.6285L27.547 16.0908L27.4222 15.9763L16.8292 27.5139L16.9539 27.6285ZM15.2379 28.6985C15.8958 28.5048 16.4889 28.135 16.9539 27.6285L16.8292 27.5139C16.3849 27.9978 15.8184 28.3511 15.1901 28.536L15.2379 28.6985ZM12.083 29.6271L15.2379 28.6985L15.1901 28.536L12.0352 29.4646L12.083 29.6271ZM12.1168 29.4838L7.22854 24.9415L7.11325 25.0656L12.0015 29.6079L12.1168 29.4838ZM8.68207 19.9433C8.21707 20.4498 7.89767 21.0739 7.75797 21.7487L7.92382 21.7831C8.05733 21.1381 8.36257 20.5418 8.80683 20.0579L8.68207 19.9433ZM19.2751 8.40569L8.68207 19.9433L8.80683 20.0579L19.3998 8.52023L19.2751 8.40569ZM7.25382 25.0207L7.92382 21.783L7.75797 21.7487L7.08797 24.9864L7.25382 25.0207Z",
    fill: "url(#paint1_linear_1971_75039)",
    mask: "url(#path-2-inside-1_1971_75039)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1971_75039)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.41438,
    height: 1.85448,
    rx: 0.92724,
    transform: "matrix(-0.732551 -0.680712 -0.676308 0.736619 26.1276 14.7719)",
    fill: "url(#paint2_linear_1971_75039)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.0615222,
    y: 0.00244136,
    width: 7.32705,
    height: 1.76714,
    rx: 0.883572,
    transform: "matrix(-0.732551 -0.680712 -0.676308 0.736619 26.0226 14.7306)",
    stroke: "url(#paint3_linear_1971_75039)",
    strokeWidth: 0.0873362
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0592 29.5463L7.1709 25.0039L6.16649 29.8561C6.02424 30.5433 6.66119 31.1352 7.33084 30.9381L12.0592 29.5463Z",
    fill: "url(#paint4_linear_1971_75039)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1971_75039",
    x: 5.40814,
    y: 6.10235,
    width: 24.3298,
    height: 25.2063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.88138
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1971_75039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1971_75039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1971_75039",
    x: 15.1628,
    y: 5.44793,
    width: 15.244,
    height: 14.9668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.33054
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1971_75039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1971_75039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1971_75039",
    x1: -0.339782,
    y1: -2.50077,
    x2: 14.7813,
    y2: 2.80876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6791E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1971_75039",
    x1: 5.68488,
    y1: 9.83609,
    x2: 35.5815,
    y2: 24.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1971_75039",
    x1: 7.55596,
    y1: 1.03405,
    x2: -3.14582,
    y2: 0.76162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1971_75039",
    x1: 7.33312,
    y1: 1.27542,
    x2: 3.70711,
    y2: 1.85394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1971_75039",
    x1: 7.63239,
    y1: 24.1998,
    x2: 10.2277,
    y2: 32.6355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6791E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoft);
export default __webpack_public_path__ + "static/media/soft.81ecc5c08898ff6c7e610eea2ec51082.svg";
export { ForwardRef as ReactComponent };